export default "__VITE_ASSET__DPUl2sWb__"